import { Button, Typography } from '@altibox/design-system-component-lib';
import { Link } from 'react-router-dom';
import { css, styled } from 'styled-components';

import { SmallContainer } from 'app/components/container';
import { Image } from 'app/components/image';
import { Link as ExternalLink } from 'app/components/link';
import { breakpointLargeTablet } from 'app/style/breakpoints';
import { colorSecondary050, colorSecondary800, colorSecondary900 } from 'app/style/colors';
import { focus } from 'app/style/mixins';
import { spacing2 } from 'app/style/spacing';

const commonLinkStyles = css`
    color: ${colorSecondary900};
    font-weight: bold;
    text-decoration: none;
    border-bottom: 2px solid ${colorSecondary900};
    padding-bottom: 2px;

    &:hover {
        color: ${colorSecondary800};
        border-bottom: 2px solid ${colorSecondary800};
    }
`;

export const StyledBreadcrumb = styled.div`
    background: ${colorSecondary050};
    height: 48px;

    @media (min-width: ${breakpointLargeTablet}) {
        height: 72px;
    }
`;

export const StyledContainer = styled(SmallContainer)`
    display: flex;
    height: 100%;
    align-items: center;
`;

export const StyledLinkContainer = styled.div`
    color: ${colorSecondary900};
    font-weight: bold;
    font-size: 20px;

    &:first-child {
        padding-left: ${spacing2};
    }

    &:not(:last-child)::after {
        content: '/';
        padding: 0 ${spacing2};
    }
`;

export const StyledLink = styled(Link)`
    font-size: 18px;
    ${focus};
    ${commonLinkStyles};
`;

export const StyledButton = styled(Button)`
    margin: 0;
    padding: 0;
`;

// FIXME: This needs to be fixed in common component library;
export const StyledArrowLeftIcon = styled(Image)`
    width: 18px !important; /* stylelint-disable-line declaration-no-important */
    height: 14px !important; /* stylelint-disable-line declaration-no-important */
    margin-right: 0 !important; /* stylelint-disable-line declaration-no-important */
`;

export const StyledText = styled(Typography)`
    font-weight: bold;
`;

export const StyledExternalLink = styled(ExternalLink)`
    ${commonLinkStyles};
`;
